/**
 * UPLOAD ERROR - FILE READING ERROR PAGE
 *
 * @version 0.1
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import reduxStore from './../../../../reduxStore';
import utils from './../../../../utils/utilities';

import actions from './../../BatchUpload.actions';

import {
    Cell,
    MessageCodesCell 
} from './../../../../reusable/CustomTableBody/templates/CustomTableBody.predefinedCellTypes.jsx';
import CustomTableBody from './../../../../reusable/CustomTableBody/CustomTableBody.index.jsx';
import InfiniteScrollTable from './../../../../reusable/InfiniteScrollTable/InfiniteScrollTable.index.jsx';

export default class FileReadingError extends React.Component {

    constructor(props) {
        super(props);
        this.state = reduxStore.getState().batchUpload;

        /*
         * We initialize all table parameters here because they will stay fixed and in the past we did the mistake of
         * initializing them in the render() method, thus causing the table to unnecessarily re-render. This caused bug
         * RMM-367 ({@link https://jira.moreover.com/browse/RMM-367}).
         */
        this.columnWidths = [7, 15, 15, 15, 15, 33];

        this.urlParams = {
            sortBy: 'rowNumber',
            direction: 'asc'
        };

        this.rowsModel = [
            {
                fieldId: 'rowNumber',
                fieldType: 'number',
                format: (value) => {
                    return (value > 0 ? <span>{value}</span> : <FormattedMessage id="General_CoreFunctionality_UIText_general.notAvailable" />);
                }
            },
            {
                fieldId: 'companyTitle',
                fieldType: Cell
            },
            {
                fieldId: 'companyName',
                fieldType: Cell
            },
            {
                fieldId: 'dunsNumber',
                fieldType: Cell
            },
            {
                fieldId: 'experianBusinessId',
                fieldType: Cell
            },
            {
                fieldId: 'errorCode',
                fieldType: MessageCodesCell
            }
        ];

        this.resetUploadAndSelectFile = this.resetUploadAndSelectFile.bind(this);
    }

    componentWillMount() {
        this.unsubscribe = reduxStore.subscribe(
            () => {
                this.setState(reduxStore.getState().batchUpload);
            }
        );
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    resetUpload() {
        actions.resetUploadToInitial();
    }

    resetUploadAndSelectFile() {
        actions.resetUploadToInitial();
        this.props.triggerSelectFile();
    }

    render() {

        return (

            <div className="file-reading-error">
                <div className="upload-preview-page__notice">
                    <div className="content">
                        <FormattedMessage id="Entities_Review_Error_errorCompanies.FileReading" />
                    </div>
                </div>

                <InfiniteScrollTable tableId="error-page-table"
                                     columnWidths={this.columnWidths}
                                     rowsModel={this.rowsModel}>
                    <thead className="custom-table-head">
                        <tr>
                            <th><FormattedMessage id="Entities_Review_Error_errorCompanies.row" /></th>
                            <th><FormattedMessage id="Entities_Review_Error_errorCompanies.CompanyTitle" /></th>
                            <th><FormattedMessage id="Entities_Review_Error_errorCompanies.CompanyName" /></th>
                            <th><FormattedMessage id="Entities_Review_Error_errorCompanies.CompanyDuns" /></th>
                            <th><FormattedMessage id="Entities_Review_Error_errorCompanies.CompanyExperian" /></th>
                            <th><FormattedMessage id="Entities_Review_Error_errorCompanies.ErrorDescription" /></th>
                        </tr>
                    </thead>
                    <CustomTableBody tableId="error-page-table"
                                     url={ '/api/template/temp-errors/' + this.state.uploadId }
                                     startPageNumber="0"
                                     pageSize="50"
                                     urlParams={this.urlParams}
                                     emptyCellMessageId="General_CoreFunctionality_UIText_general.emptyCellDescription" />
                </InfiniteScrollTable>

                <div className="upload-preview-page__bottom-buttons">

                    <button className="button-primary-lg app-button return"
                            onClick={this.resetUpload}>
                        <FormattedMessage id="Entities_Review_Error_errorCompanies.ReturnToBatchUpload" />
                    </button>

                    <button className="button-primary-lg app-button upload"
                            onClick={this.resetUploadAndSelectFile}>
                        <FormattedMessage id="Entities_Review_Error_errorCompanies.UploadNewFileButton" />
                    </button>

                </div>

            </div>

        );

    }
}



// WEBPACK FOOTER //
// ./src/scripts/pages/BatchUpload/submodules/ErrorPage/ErrorPage.fileReadingError.jsx